import Image from 'next/image'
import { useTheme } from '@mui/material'

import Button from '../button'
import GoogleLogo from 'public/assets/google-logo.png'

const GoogleBtn = (props: { onClick: () => void; text: string; loading?: boolean }) => {
    const { loading } = props
    const { palette } = useTheme()
    return (
        <Button
            startIcon={<Image alt="login with google" height={20} width={20} src={GoogleLogo} />}
            fullWidth
            loading={loading}
            size="large"
            variant="outlined"
            style={{ borderColor: palette.action.disabledBackground, color: palette.common.white }}
            onClick={() => props.onClick()}>
            {props.text}
        </Button>
    )
}

export default GoogleBtn
